export const AVATAR_PARTS = [
  'container',
  'label',
  'badge',
  'group',
  'excessLabel',
] as const;
